export default __webpack_public_path__ + "static/media/bank-red.6a1320b7.svg";